export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/service-vip.4f5e9ad8-959232.png";